import {useMemberStore} from '~/store/member/index.js'

export default defineNuxtPlugin(async nuxtApp => {
  try {
    const store = useMemberStore()
    const config = useRuntimeConfig()
    // 인증상태 체크
    const tokenCookie = useCookie('access-token')
    if (tokenCookie.value) {
      store.setAccessToken(tokenCookie.value)
      const res = await $fetch('/member/verify', {
        baseURL: config.public.apiBaseUrl,
        method: 'POST',
        body: {
          accessToken: tokenCookie.value
        }
      })
      if (res?.result?.code === 200) {
        store.setMember(res.data)
      }
    }
  } catch (error) {
    console.log(error)
  }
})
